/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getStudentCertificateApi } from "@/api/reportingApi";

export const getStudentCertificateThunk = createAsyncThunk<
    any,
    {
        studentId: number;
        productFamilyGradeId: number;
        type: string;
        term?: number;
        courseId?: number;
        subjectId?: number;
    },
    { rejectValue: string }
>(
    "reporting/certificate/fetch",
    async ({ studentId, productFamilyGradeId, type, term, courseId, subjectId }, { rejectWithValue }) => {
        try {
            const { data } = await getStudentCertificateApi(
                studentId,
                productFamilyGradeId,
                type,
                term,
                courseId,
                subjectId
            );
            return data?.data;
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message ??
                    err?.message ??
                    "Failed to load certificate"
            );
        }
    }
);
